import * as React from "react";

import "./upload-card.scss";

import {cs} from "@Common/react/chain-services";

import {UploadModal} from "./upload-modal/upload-modal";

export const UploadCard = ({
    type,
    onUpload,
}: {
    type: string,
    onUpload: (data) => any,
}) => ({
    render: () => cs(
        ["modal", (_, next) => UploadModal({
            title: type,
            onUpload,
            placeholder: (
                type === "Headshot" ? (
                    "i.e. John Doe Agent"
                ) : (
                    "i.e. Logo Name"
                )
            ),
            allowDefaultOption: type === "Headshot",
            next,
        })],
        ({modal}) => (
            <div className="upload-card">
                <div className="text">
                    {type}s must be in JPEG (.jpg, .jpeg), PNG, or PDF format.
                </div>
                <button
                    className="upload" 
                    xd-qa-type="button" 
                    xd-qa-name="UPLOAD NEW"
                    onClick={() => modal.show()}
                >
                    UPLOAD NEW
                </button>
            </div>
        )
    )
});

